import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-btn',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './btn.component.html',
  styleUrl: './btn.component.css'
})
export class BtnComponent {

  @Input() txtAlign: ('center' | 'left' | 'right') = 'center';
  @Input() padding: string | null = null;
  @Input() disabled: boolean = false;
  @Input() color: ('mf-primary' | null) = null;

}
